import type { ReactNode } from 'react';
import { type FeatureKey, useFeatures } from '../lib/features';
import { NotFoundRoute } from '../routes/NotFoundRoute';

/**
 * Route-level feature gate. Renders children when the flag is on, otherwise
 * shows the 404 page — matching what the user would see if they hit an
 * unmapped URL. Using 404 (rather than a "coming soon" page) keeps the
 * disabled feature invisible, which is what we want pre-launch.
 *
 * While features are still loading we also render 404. Worst case a user
 * reloads a gated page and sees 404 for ~100ms before the flag resolves;
 * flashing a live page and then yanking it is a worse UX.
 */
export function FeatureGated({ feature, children }: { feature: FeatureKey; children: ReactNode }) {
  const { features, loaded } = useFeatures();
  if (!loaded || !features[feature]) return <NotFoundRoute />;
  return <>{children}</>;
}
